import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../types/user-type.type';

// No seu arquivo de serviços (user.service.ts)
export interface BasicUserResponse {
  data: BasicUser[];
}

export interface BasicUser {
  id: number;
  shortName: string;
  // Adicione outras propriedades que o endpoint /user/all realmente retorna
  name?: string;
  cpf?: string;
  role?: string;
  email?: string;
}

export interface UserResponse {
  data: { id: number; shortName: string; }[];
}

export interface RoleResponse {
  data: { id: number; name: string; description: string }[];
}


export interface UserSearchResponse {
  data: User[];
  total: number;
  page: number;
  limit: number;
}

export interface PageableUsersData {
  content: User[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getUsers(): Observable<BasicUserResponse> {
    const url = `${this.apiUrl}/nucon/api/v1/user/all`;
    return this.http.get<BasicUserResponse>(
      url, { withCredentials: true }
    );
  }

  getSearchUsers(searchTerm?: string, page: number = 1, limit: number = 10): Observable<UserSearchResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (searchTerm) {
      params = params.set('search', searchTerm);
    }
    const url = `${this.apiUrl}/nucon/api/v1/user/all`;
    return this.http.get<UserSearchResponse>(url, { params });
  }

  getUserById(id: number): Observable<User> {
    const url = `${this.apiUrl}/nucon/api/v1/user/${id}`;
    return this.http.get<User>(url);
  }


  getRoles(): Observable<RoleResponse> {
    const url = `${this.apiUrl}/nucon/api/v1/user/roles`;
    return this.http.get<RoleResponse>(
      url, { withCredentials: true }
    );
  }

  setUserById(id: number, userData: any): Observable<any> {
    const url = `${this.apiUrl}/nucon/api/v1/user/update/${id}`;
    return this.http.put<User>(url, userData, { withCredentials: true });
  }



  getUsersByFilter(
    userId?: number,
    role?: string,
    page: number = 0,
    size: number = 10
  ): Observable<PageableUsersData> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (userId) params = params.set('userId', userId.toString());
    if (role) params = params.set('role', role);

    const url = `${this.apiUrl}/nucon/api/v1/user/filter`;
    return this.http.get<PageableUsersData>(
      url , { params });
  }



}
